<template>
  <div class="address-book-wrapper">
    <div v-if="viewMode === 'list'" class="address-book-container">
      <div class="fixed-tools">
        <div
          v-for="tool in tools"
          :key="tool.name"
          class="tool-item"
          @click="handleToolClick(tool)"
        >
          <div class="icon-wrapper" :style="{ backgroundColor: tool.bgColor }">
            <i :class="tool.icon" />
          </div>
          <span class="tool-name">{{ tool.name }}</span>
        </div>
      </div>

      <div v-for="group in contacts" :key="group.letter" class="contacts-group">
        <div class="group-letter">{{ group.letter }}</div>
        <div
          v-for="user in group.list"
          :key="user.userId"
          class="contact-item"
          @click="enterUserDetail(user)"
        >
          <el-avatar :size="36" shape="square" :src="user.avatarUrl" />
          <span class="contact-name">{{ user.screenName }}</span>
        </div>
      </div>
    </div>

    <div v-else-if="viewMode === 'detail' && selectedUser" class="wechat-detail-page">
      <header class="detail-header">
        <div class="back-btn" @click="backToList">
          <i class="el-icon-arrow-left" />
        </div>
        <i class="el-icon-more right-icon" @click="handleMore" />
      </header>

      <div class="user-detail-card">
        <div class="profile-header">
          <div class="info-left">
            <h2 class="user-nickname">{{ selectedUser.screenName }}</h2>
            <p class="wechat-id">微信号：{{ selectedUser.username }}</p>
            <p class="region-text">地区：{{ area }}</p>
          </div>
          <el-avatar :size="64" shape="square" :src="selectedUser.avatarUrl" class="profile-avatar" />
        </div>

        <hr class="divider">

        <div class="detail-rows">
          <div class="detail-row">
            <span class="row-label">标签</span>
            <span class="row-value placeholder">无</span>
          </div>
          <div class="detail-row">
            <span class="row-label">朋友圈</span>
            <div class="pyq-previews">
              <div class="pyq-box" />
              <div class="pyq-box" />
            </div>
          </div>
          <div class="detail-row">
            <span class="row-label">更多信息</span>
            <span class="row-value placeholder">个性签名或出处</span>
          </div>
        </div>

        <div class="action-buttons">
          <el-button type="default" icon="el-icon-chat-dot-round" class="btn-wechat" @click="goToChat">
            发消息
          </el-button>
          <el-button type="default" icon="el-icon-video-camera" class="btn-wechat" @click="goToDial">
            音视频通话
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getContacts } from '@/api/chat'

export default {
  name: 'ChatAddressBook',
  data() {
    return {
      // 核心控制变量：'list' 代表通讯录列表，'detail' 代表全屏用户详情
      viewMode: 'list',
      selectedUser: null,
      area: '四川 成都',
      tools: [
        { name: '新的朋友', icon: 'el-icon-user-solid', bgColor: '#fa9d3b' },
        { name: '群聊', icon: 'el-icon-phone', bgColor: '#46c11b' },
        { name: '标签', icon: 'el-icon-collection-tag', bgColor: '#3cc51f' },
        { name: '公众号', icon: 'el-icon-s-promotion', bgColor: '#0bb20c' }
      ],
      contacts: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getContacts().then(resp => {
        if (resp.code === 0) {
          this.contacts = resp.data
        }
      })
    },
    handleToolClick() {
      this.$message.info('功能开发中')
    },
    /**
     * 点击联系人：保存当前用户并原地切换到详情全屏视图
     */
    enterUserDetail(user) {
      this.selectedUser = user
      this.viewMode = 'detail'
    },

    handleMore() {
      this.$message.info('功能开发中')
    },

    /**
     * 点击左上角返回：切回列表视图
     */
    backToList() {
      this.viewMode = 'list'
      this.selectedUser = null
    },

    /**
     * 联动：点击发消息跳转至实际聊天会话页面
     */
    goToChat() {
      this.$router.push({
        path: '/chat/dialogue',
        query: {
          chatId: this.selectedUser.chatId
        }
      })
      /* this.viewMode = 'list'
      this.selectedUser = null*/
    },
    goToDial() {
      /* this.viewMode = 'list'
      this.selectedUser = null*/
      this.$message.info('尚未实现')
    }
  }
}
</script>

<style scoped>
/* 统筹外层包裹器 */
.address-book-wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
}

/* ==================== 1. 通讯录列表样式 ==================== */
.address-book-container {
  background-color: #f7f7f7;
}
.fixed-tools {
  background-color: #fff;
  margin-bottom: 8px;
}
.tool-item, .contact-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid #f2f2f2;
  background-color: #fff;
  cursor: pointer;
}
.tool-item:active, .contact-item:active {
  background-color: #f5f5f5;
}
.icon-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
}
.tool-name, .contact-name {
  margin-left: 14px;
  font-size: 16px;
  color: #191919;
}
.group-letter {
  padding: 4px 16px;
  font-size: 12px;
  color: #888;
  background-color: #f7f7f7;
}

/* ==================== 2. 全屏用户详情独立视图样式 ==================== */
.wechat-detail-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff; /* 微信详情卡片底色为纯白 */
  box-sizing: border-box;
  padding: 0 24px 40px 24px;
  z-index: 10; /* 确保覆盖层级 */
}

/* 详情页顶部导航栏 */
.detail-header {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  color: #191919;
  margin-bottom: 20px;
}
.back-btn {
  cursor: pointer;
  padding: 4px;
}
.right-icon {
  cursor: pointer;
}

/* 资料卡头部主体 */
.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 10px;
}
.info-left {
  flex: 1;
  padding-right: 16px;
}
.user-nickname {
  font-size: 22px;
  font-weight: 600;
  color: #191919;
  margin: 0 0 8px 0;
}
.wechat-id, .region-text {
  font-size: 13px;
  color: #7f7f7f;
  margin: 4px 0;
}
.profile-avatar {
  border-radius: 6px;
  flex-shrink: 0;
}

/* 模块分割线 */
.divider {
  border: none;
  border-top: 1px solid #f0f0f0;
  margin: 24px 0 16px 0;
}

/* 中部扩展功能项 */
.detail-rows {
  margin-bottom: 44px;
}
.detail-row {
  display: flex;
  align-items: center;
  padding: 14px 0;
  font-size: 14px;
  border-bottom: 1px solid #fafafa;
}
.row-label {
  width: 80px;
  color: #191919;
  font-weight: 500;
}
.row-value {
  color: #191919;
}
.row-value.placeholder {
  color: #b3b3b3;
}

/* 朋友圈微缩图缩略盒 */
.pyq-previews {
  display: flex;
  gap: 6px;
}
.pyq-box {
  width: 42px;
  height: 42px;
  background-color: #f2f2f2;
  border-radius: 4px;
}

/* 底部功能按钮组 */
.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.btn-wechat {
  width: 100%;
  height: 44px;
  margin: 0 !important;
  font-size: 15px;
  font-weight: 500;
  border: none;
  background-color: #f2f2f2;
  color: #576b95; /* 微信经典的深蓝链接色 */
  transition: background-color 0.1s;
}
.btn-wechat:active {
  background-color: #e5e5e5;
}
</style>
